<nz-spin [nzSpinning]="loading">
  <app-edit-wmsm-ElectronicInvoice [index]="index" *ngIf="index==0" >
  </app-edit-wmsm-ElectronicInvoice>
<!-- <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" [(nzSelectedIndex)]="index"
  class="imprcs002-tab-box">
  <nz-tab  >
    <ng-template nz-tab>
      <app-edit-wmsm-ElectronicInvoice [index]="index" *ngIf="index==0" >
      </app-edit-wmsm-ElectronicInvoice>
    </ng-template>
  </nz-tab>

   <nz-tab [nzTitle]="'ManualInvoice'|translate" >
    <ng-template nz-tab >
      <app-edit-wmsm-ManualInvoice [index]="index" *ngIf="index==1"   >
      </app-edit-wmsm-ManualInvoice>
    </ng-template>
  </nz-tab> -->

<!-- </nz-tabset>  -->

</nz-spin>